// ─────────────────────────────────────────────
//  EquivalenceCard.jsx — Equivalences section
//  Mirror of PerPerson.jsx structure
// ─────────────────────────────────────────────

import React from 'react';
import styles from './EquivalenceCard.module.css';

export default function EquivalenceCard({
	winner,
	equivalentUnits,
	costOfEquivalent,
	savingsAmount,
	winnerPrice,
	loserPrice,
	loserLabel,
	unit,
}) {
	// loserLabel comes from PriceComparator (handles 2 or 3 products)
	const loser = loserLabel || (winner === 'A' ? 'B' : 'A');
	const unitsDisplay = equivalentUnits.toFixed(1);
	const ceiled = Math.ceil(equivalentUnits);
	const ceiledCost = (ceiled * winnerPrice).toFixed(2);
	const savingsAbs = Math.abs(savingsAmount).toFixed(2);
	const winnerSavesVsLoser = savingsAmount > 0;

	return (
		<div className={styles.card}>
			<p className={styles.label}>¿Cuánto equivale?</p>

			<div className={styles.row}>
				<div className={`${styles.iconCircle} ${styles.green}`}>
					<span aria-hidden="true">📦</span>
				</div>
				<p className={styles.text}>
					<strong>{unitsDisplay} unidades</strong> del Producto {winner} equivalen a 1 del Producto {loser}
				</p>
			</div>

			<div className={styles.row}>
				<div className={`${styles.iconCircle} ${styles.amber}`}>
					<span aria-hidden="true">💰</span>
				</div>
				<p className={styles.text}>
					Comprar {ceiled} {winner} cuesta <strong>${ceiledCost}</strong>
					{winnerSavesVsLoser
						? ` — $${savingsAbs} menos que ${loser}`
						: ` — apenas $${savingsAbs} más que ${loser} con igual volumen`}
				</p>
			</div>

			<div className={styles.row}>
				<div className={`${styles.iconCircle} ${styles.green}`}>
					<span aria-hidden="true">👍</span>
				</div>
				<p className={styles.text}>
					<strong>Producto {winner}</strong> gana — más barato por {unit}
					{equivalentUnits > 2
						? ', aunque necesitas más unidades'
						: ' y más flexible'}
				</p>
			</div>
		</div>
	);
}
